.tableScroll {
    overflow-x: auto;
    width: 100%;
}

.loadMore {
    align-self: center;
}

.expirationCell {
    align-items: center;
    gap: var(--certifications-section-expiration-cell-gap);
}
